<template >
  <v-list-item v-on="rowClickEnabled && item.rowClick ? { click: item.rowClick } : {}">
    <v-list-item-content >
      <v-list-item-title>
        <span style="padding-right: 1em;">{{item.scheduledPlannedService.device | device}}</span> <span>{{item.scheduledPlannedService.scheduleDate | date}}</span>
      </v-list-item-title>
      <v-list-item-subtitle>
        {{item.name}}
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="item.scheduledPlannedService.locationTop || item.scheduledPlannedService.locationSub">
        {{item.scheduledPlannedService.locationTop}} / {{item.scheduledPlannedService.locationSub}}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action v-if="showActions && !!item.rowActions && !!item.rowActions.length > 0">
      <entity-table-row-end-action-menu :actions="item.rowActions"/>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import EntityTableRowEndActionMenu from '@/components/entity-crud/EntityTableRowEndActionMenu';
export default {
  name: 'ScheduledPlannedServiceListItem.vue',
  components: { EntityTableRowEndActionMenu },
  props:{
    item:{
      type: Object,
      required: true,
      validator: item => {
          return  !!item.scheduledPlannedService;
      },
    },
    showActions:{
      type: Boolean,
    },
    rowClickEnabled:{
      type: Boolean,
    },
  },
};
</script>

<style scoped>

</style>
